module.exports = __webpack_public_path__ + "static/media/han-taste-ad5.8db02932.png";